import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
    ensure,
    FormDropdown,
    FormValidationSummary,
    mapToDropdownOption,
    TextField,
    ValidationResult
} from "sprint-common-web";

import { handleOptionChange } from "../../../../common/utils/handleOptionChange";
import { useAssociateContentFormContext } from "../context/useAssociateContentFormContext";
import { ensureAncillaryDetails } from "../types/ContentAssociationDetails";
import { ContentAssociationFormState } from "../types/ContentAssociationFormState";
import { createContentAssociationAncillaryItemValidator } from "./ContentAssociationAncillaryItemValidator";
import { useContentAssociationAncillaryContentForm } from "./useContentAssociationAncillaryContentForm";

export const ContentAssociationAncillaryContentForm = (): JSX.Element => {
    const { control, errors } = useFormContext<ContentAssociationFormState>();

    const [validationResult, setValidationResult] = useState<ValidationResult>();

    const { contentDetails, validation, isEditDisabled } = useAssociateContentFormContext();

    ensure(contentDetails);
    ensureAncillaryDetails(contentDetails);

    const validator = createContentAssociationAncillaryItemValidator();

    const {
        init,
        opts,
        selections: { selectAirline, clearAirline }
    } = useContentAssociationAncillaryContentForm();

    useEffect(() => {
        init();

        const result = validator.validateAncillary(contentDetails);
        setValidationResult(result);
    }, [contentDetails]);

    return (
        <>
            <FormDropdown
                options={opts.airlines.map((item) => mapToDropdownOption(item))}
                control={control}
                errors={errors}
                disabled={isEditDisabled}
                label="Airline"
                name="airlineId"
                onChange={handleOptionChange(selectAirline, clearAirline)}
                rules={{
                    required: validation.rules.isAirlineRequired ? "Search and select Airline" : false
                }}
            />

            <TextField
                value={opts.versionType}
                label="Version Type"
                placeholder="Version Type"
                data-testId="version-type-form"
                contentEditable={false}
                disabled={true}
            />
            <FormValidationSummary validationResult={validationResult} />
        </>
    );
};
